<template>
  <div class="list">
    <div @click="toDetail(item)" class="item" v-for="(item, index) in productList" :key="index">
      <p class="name">{{item.fundName}}</p>
      <div class="info">
        <div class="left">
          <p
            :style="{
            color: highEndFundColor(item.sylOfYear === '--' ? item.sylOfEstablish : item.sylOfYear )
          }"
            class="left-value"
          >{{item.sylOfYear === '--' ? item.sylOfEstablish : item.sylOfYear }}</p>
          <p class="desc">{{item.sylOfYear === '--' ? '成立来' : '近1年'}}</p>
        </div>
        <div class="right">
          <p class="right-value">{{item.operationPeriod}}</p>
          <p class="desc">{{`${item.minInvest}｜${item.riskLevel}`}}</p>
        </div>
      </div>
      <img
        class="sell-state"
        :src="sellState[parseInt(item.sellState, 10)]"
        :style="{
          width: parseInt(item.sellState, 10) === 4 ? '59px' : '50px',
          height: '22px',
        }"
      />
    </div>

    <div class="risk-tip">
      <p
        :maxFontZoomScale="1.0"
        class="tip-text"
      >非公募基金产品，本页面数据无公开渠道可供查询，我公司无法保证上述数据真实、准确、完整。请勿作为投资决策依据。</p>
    </div>
  </div>
</template>

<script>
import tool from '@/utils/tool';

export default {
  props: {
    fundCode: String,
    elementData: Object,
    mergeData: Object,
  },

  data() {
    return {
      pageSize: 10,
      pageIndex: 1,
      //  销售状态(0-购买, 1-预约, 2-已售罄, 3-即将发售)=>(0-可购；2-已售罄；4-即将开放；5-可预约；)
      sellState: {
        0: 'https://j5.dfcfw.com/imagesystem/material_imgs/1685341042955770.png',
        5: 'https://j5.dfcfw.com/imagesystem/material_imgs/1684465162621533.png',
        2: 'https://j5.dfcfw.com/imagesystem/material_imgs/1684305174891972.png',
        3: 'https://j5.dfcfw.com/imagesystem/material_imgs/1684305174891972.png',
        4: 'https://j5.dfcfw.com/imagesystem/material_imgs/1684465170617163.png',
      },
    };
  },

  computed: {
    productList() {
      const list = this.mergeData?.sameTypeProduct || [];
      // 排除基金本身
      return list.filter((item) => item.fundCode !== this.fundCode);
    },
  },

  methods: {
    highEndFundColor: tool.highEndFundColor,

    toDetail(item) {
      console.log('toDetail', item);
      if (item?.fundCode) {
        if (multi.$system.webPlatform === 'wxmp') {
          const source = `fund://mp.1234567.com.cn/weex/fundb5035dd2ee584a/pages/fund-detail-public/index?currentCode=${item.fundCode}`;
          const convertUrl = tool.getJumpUrl(source);
          if (source === convertUrl) {
            this.$goFundApp();
            return;
          }
          wx.miniProgram.navigateTo({
            url: convertUrl,
          });
          return;
        }
        multi.$router.push({
          url: '/pages/high-end-fund/index',
          params: {
            fundCode: item.fundCode,
          },
        });
      }
    },
  },
};
</script>

<style scoped>

.item {
  margin-top: 24px;
  border-radius: 24px;
  padding: 32px 24px;
  background-color: #ffffff;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;
}

.name {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #333333;
}

.info {
  display: flex;
  flex-direction: row;
  margin-top: 36px;
}

.left {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
}

.left-value, .middle-value {
  font-family: DINAlternate-Regular;
  font-size: 42px;
  color: #FF0000;
  letter-spacing: 2px;
  line-height: 42px;
  font-weight: 400;
}

.right-value {
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #333333;
  line-height: 42px;
  font-weight: 400;
}

.middle {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
}

.right {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
}

.desc {
  font-family: PingFangSC-Regular;
  font-size: 24px;
  color: #999999;
  margin-top: 12px;
}

.sell-state {
  position: absolute;
  top: 0;
  right: 24px;
}

.risk-tip {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 200px;
  padding-bottom: 600px;
}

.tip-text {
  font-size: 28px;
  color: #999999;
  text-align: center;
  line-height: 40px;
}
</style>
